import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types'
import { cloneDeep, find, findIndex, isEmpty } from "lodash";
import PhoneInput from 'react-phone-number-input'

const PhoneNumberInput = ({ handleChange }) =>
{
  const { t } = useTranslation();
  const { form } = useSelector((state) => state.form);
  const [phoneNumberField, setPhoneNumberField] = useState(find(form, { field: "phoneNumber" }))

  /**
   * useEffect hook for updating the phone number field whenever the form state is updated
   */
  useEffect(() =>
  {
    let formData = cloneDeep(form)
    let phoneNumberIndex = findIndex(formData, { field: "phoneNumber" })
    setPhoneNumberField(formData[phoneNumberIndex])
  }, [form])

  return (
    <div className="col-md-24 form-group">
      {phoneNumberField.error &&
        <div role="alert">
          <span className="alert alert-error" id="attrError2">{phoneNumberField.errorMessage}</span>
        </div>}
      {phoneNumberField.isReadOnly && !isEmpty(phoneNumberField.value) &&
        <div className={`placeholderContainer border-bottom ${phoneNumberField.error && "has-error"}`}>
          <input
            type="text"
            autoComplete="off"
            className="form-control text-box cursor-disabled read-only-field"
            value={phoneNumberField.value}
            readOnly />
        </div>}
      {!phoneNumberField.isReadOnly &&
        <div className={`placeholderContainer border-bottom ${phoneNumberField.error && "has-error"}`}>
          <PhoneInput
            placeholder={`${t('widget.phoneNumber.phoneNumberPlaceholder')} ${phoneNumberField.mandatory ? "" : t('widget.placeholderOptional')}`}
            international={true}
            countryCallingCodeEditable={false}
            value={phoneNumberField.value}
            onChange={(number) => handleChange("phoneNumber", number)}
            maxLength={20} />
        </div>}
    </div>
  );
};

PhoneNumberInput.propTypes = {
  handleChange: PropTypes.func
};

export default PhoneNumberInput;